import { render, staticRenderFns } from "./QuoteTemplateMiscView.vue?vue&type=template&id=1678e344"
import script from "./QuoteTemplateMiscView.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateMiscView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1678e344')) {
      api.createRecord('1678e344', component.options)
    } else {
      api.reload('1678e344', component.options)
    }
    module.hot.accept("./QuoteTemplateMiscView.vue?vue&type=template&id=1678e344", function () {
      api.rerender('1678e344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateMiscView.vue"
export default component.exports